<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="container-fluid service-container">
          <home-title title="THE SERVICE SECTOR" subTitle="服务领域" />
          <div class="row service-wrapper">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="row">
                <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                  <div class="service-item">
                    <p class="service-title">我们的服务</p>
                    <p class="service-sub-title">懂您所需、做您所想</p>
                    <div class="line"></div>
                    <p class="service-item-content text-indent">
                      服务于行政事业单位十多年，熟悉财政业务，也是天圆全会计事务所广东分所的高级项目经理，对单位审计等业务精通。可以为您单位提供全面的财政系统问题，财务问题，单位内控问题等专业的咨询服务及系统软件服务。
                    </p>
                    <div class="bottom-line"></div>
                  </div>
                  <div class="service-item">
                    <p class="service-title">我们能做什么？</p>
                    <p class="service-sub-title">我们提供的业务</p>
                    <div class="line"></div>
                    <p class="service-item-content">1. 决算系统：决算数据填报；</p>
                    <p class="service-item-content">2. 全年财务系统咨询服务和年末指导对账服务包括财务系统开帐和结转的生成等服务；</p>
                    <p class="service-item-content">3. 内控系统服务(主要帮助报送系统)；</p>
                    <p class="service-item-content">4. 政府财务报告系统服务；</p>
                    <p class="service-item-content">5. 其他财政系统相关业务培训等；</p>
                    <p class="service-item-content">6. 固定资产服务，可以提供固定资产实物管理系统和制度等咨询和服务；</p>
                    <p class="service-item-content">7. 内控系统制度咨询和建设；</p>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 text-right imgs-wrapper">
                  <img src="../assets/service/ser1.png" alt="服务" />
                  <img src="../assets/service/ser2.png" alt="服务" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row reason">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="container-fluid service-container">
          <div class="service-reason-title">
            <p class="reason-title">选择我们的理由</p>
            <p class="reason-sub-title">REASONS FOR CHOOSING US</p>
            <span class="reason-line"></span>
          </div>
          <div class="row service-wrapper reason-wrapper hidden-xs">
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r1.png" alt="全国覆盖" />
              <p class="item-title">全国覆盖</p>
              <p class="item-content">专业平台，覆盖全国地区</p>
              <p class="item-content">为企业资产保驾护航</p>
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <p class="item-title">专业系统</p>
              <p class="item-content">专业财政财务信息管理、信息化建 设架构体系，为您量身定制。</p>
              <img class="img-responsive" src="../assets/service/r2.png" alt="专业系统" />
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r3.png" alt="全国覆盖" />
              <p class="item-title">决算服务</p>
              <p class="item-content">还在为决算数据烦恼吗？我们提供完 善的决算服务。</p>
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <p class="item-title">顾问服务</p>
              <p class="item-content">可为您单位提供全面的财务问题 单位内控问题等专业的咨询服务。</p>
              <img class="img-responsive" src="../assets/service/r4.png" alt="顾问服务" />
            </div>
          </div>
          <div class="row service-wrapper reason-wrapper visible-xs">
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r1.png" alt="全国覆盖" />
              <p class="item-title">全国覆盖</p>
              <p class="item-content">专业平台，覆盖全国地区</p>
              <p class="item-content">为企业资产保驾护航</p>
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r2.png" alt="专业系统" />
              <p class="item-title">专业系统</p>
              <p class="item-content">专业财政财务信息管理、信息化建 设架构体系，为您量身定制。</p>
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r3.png" alt="全国覆盖" />
              <p class="item-title">决算服务</p>
              <p class="item-content">还在为决算数据烦恼吗？我们提供完 善的决算服务。</p>
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <img class="img-responsive" src="../assets/service/r4.png" alt="顾问服务" />
              <p class="item-title">顾问服务</p>
              <p class="item-content">可为您单位提供全面的财务问题 单位内控问题等专业的咨询服务。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeTitle from "@/components/home/homeItemTitle.vue";
export default {
  name: "Services",
  components: {
    HomeTitle,
  },
};
</script>
<style scoped>
.service-container {
  margin-top: 24px;
}
.service-wrapper {
  padding: 20px 62px 0 62px;
}
.service-item {
  padding-top: 30px;
  padding-bottom: 40px;
}
.service-title {
  font-size: 18px;
  color: #333333;
  font-weight: 500;
}
.service-sub-title {
  font-size: 12px;
}
.line {
  width: 42px;
  height: 1px;
  background: #3b6fdf;
  margin: 10px 0 16px 0;
}
.service-item-content {
  font-size: 14px;
  color: #666666;
}
.text-indent {
  text-indent: 18px;
}
.bottom-line {
  width: 258px;
  height: 1px;
  border-top: 1px dotted #d2d2d2;
  margin-top: 14px;
}
.imgs-wrapper > img {
  width: 80%;
  margin: 30px 0 30px 0;
}
.reason {
  background-color: #f6f6f6;
}
.service-reason-title {
  text-align: center;
}
.reason-wrapper {
  padding-top: 20px;
  padding-bottom: 40px;
}
.reason-title {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
}
.reason-sub-title {
  font-size: 12px;
  color: #cccccc;
  margin: 8px 0 12px 0;
}
.reason-line {
  width: 27px;
  height: 2px;
  display: inline-block;
  background: #346bdc;
}
.item-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin: 8px 0;
}
.item-content {
  font-size: 12px;
  color: #7a7a7a;
  line-height: 16px;
  margin: 8px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/services.vue